(InnStyle = function (domain, opts) {
  if (!domain && !opts) {
    return;
  }
  var options = {
      width: "100%",
      height: 500,
      domain: domain,
      unique: `iframe-${Math.random().toString(36).substring(2, 5)}`,
      color: "dark", // light, dark
      policy: "show", // hide, show
      target: null,
      bookable: null,
      date_in_view: null,
      offset: 0, // useful if fixed position navbar
      calendar: "show", // show, hide
      packages: "show", // show, hide
      protocol: "https",
      env: "innstyle.co.uk",
      datepicker: "all",
      custom_enquiry_page: false,
      calendar_for: null,
      force_enquiry: null,
      force_calendar: null,
      staylist_search: false,
      ignore_default_css: null,
      no_bookable_name: null,
      force_id: null,
      ga: null,
      start_date: null,
      nights: null,
      adults: 2,
      infants: null,
      children: null,
      child_ages: null,
      dogs: null,
      console_debug: false, // this can be changed after load with window.innstyle_console_debug = true
      secret_code: null,
      listing: null,
      enquiry: null,
      locale: "en",
      path: null,
      destination: null,
      host: null,
      overflow: 500,
      zIndex: 1,
    },
    repainted = false,
    log = function () {
      if (innstyle_console_debug) {
        console.log.apply(console.log, arguments);
      }
    },
    ext = function (object1, object2) {
      for (var key in object2) {
        if (key in object1) {
          if (object1[key] && object1[key].constructor == Object) {
            ext(object1[key], object2[key]);
          } else {
            object1[key] = object2[key];
          }
        }
      }
    },
    render = function (tpl, data) {
      var output = tpl,
        dotData = function (d, dotKey) {
          var invert = "";
          if (dotKey.indexOf("!") > -1) {
            dotKey = dotKey.replace(/!/gi, "");
            invert = "!";
          }
          try {
            val = eval(invert + "d['" + dotKey.split(".").join("']['") + "']");
          } catch (e) {
            val = "";
          }
          return val;
        },
        matches = tpl.match(/\{\{[^}}]*\}\}/gim);
      for (var i = 0; i < matches.length; ++i) {
        var m = matches[i],
          val = dotData(data, matches[i].replace(/\{\{|\}\}/gi, "")) || "";
        output = output.replace(new RegExp(m, "igm"), val);
      }
      return output;
    },
    build_path = function () {
      if (options.host) {
        base = "//{{host}}";
      } else {
        base = "//{{domain}}.{{env}}";
      }

      if (options.path) {
        base = base + options.path;
      } else if (options.calendar_for) {
        base = base + "/calendar/" + String(options.calendar_for);
      } else if (options.custom_enquiry_page) {
        base = base + "/custom_enquiries/" + options.enquiry;
      } else if (options.force_enquiry) {
        base = base + "/enquiries/" + options.enquiry;
      } else if (options.staylist_search) {
        base = base + "/form";
      } else if (options.listing && options.enquiry) {
        base =
          base +
          "/listings/" +
          options.listing +
          "/enquiries/" +
          options.enquiry;
      } else if (options.listing && options.force_calendar) {
        base = base + "/listings/" + options.listing + "/calendars";
      } else if (options.listing) {
        base = base + "/listings/" + options.listing;
      } else if (options.enquiry) {
        base = base + "/enquiries/" + options.enquiry;
      }

      function setCustomOrForcedEnquiryId() {
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const customEnquiryId = urlParams.get("custom_enquiry_id");
          return customEnquiryId || options.force_enquiry;
        } catch (error) {
          return options.force_enquiry;
        }
      }

      let customURLParams = {
        iframe: "1",
        locale: options.locale,
        color: options.color,
        policy: options.policy,
        bookable_id: options.bookable,
        date_in_view: options.date_in_view,
        calendar: options.calendar,
        packages: options.packages,
        datepicker: options.datepicker,
        custom_enquiry_page: options.custom_enquiry_page,
        force_enquiry: setCustomOrForcedEnquiryId(),
        no_iframe_css: options.ignore_default_css,
        no_bookable_name: options.no_bookable_name,
        bo: options.force_id,
        start_date: options.start_date,
        secret_code: options.secret_code,
        nights: options.nights,
        adults: options.adults,
        infants: options.infants,
        children: options.children,
        child_ages: options.child_ages,
        dogs: options.dogs,
        destination_id: options.destination,
      };
      let compactCustomURLParams = Object.entries(customURLParams).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {},
      );
      let customQueryString = new URLSearchParams(
        compactCustomURLParams,
      ).toString();

      return base + "?" + customQueryString;
    },
    build_secure_path = function () {
      if (options.host) {
        return "https://{{host}}";
      } else if (options.env != "innstyle.co.uk") {
        return "{{protocol}}://{{domain}}.{{env}}";
      } else {
        return "https://{{domain}}.{{env}}";
      }
    },
    google_track = function () {
      if (typeof ga != "function") {
        log(
          "Cannot do GA tracking; GA has not been loaded in globally available ga variable",
        );
        return;
      }
      ga("create", options.ga, "auto");
      ga(function (tracker) {
        var clientId = tracker.get("clientId");
        var frameWindow =
          document.getElementById("InnStyle_iFrame1").contentWindow;
        var destination = render(build_secure_path(), options);
        log("postMessage clientID: " + clientId);
        log("postMessage destination: " + destination);
        frameWindow.postMessage(clientId, destination);
      });
    },
    build = function () {
      var scripts = document.scripts[document.scripts.length - 1],
        div = document.createElement("div"),
        iframe = document.createElement("iframe");
      div.id = "InnStyle_Container1";
      div.style.position = "relative";
      div.style.zIndex = options.zIndex;
      iframe.id = "InnStyle_iFrame1";
      iframe.title = "InnStyle Booking Engine";
      iframe.name = options.unique;
      iframe.src = render(build_path(), options);
      iframe.width = options.width;
      iframe.height = "100%";
      iframe.frameBorder = 0;
      iframe.scrolling = "yes";
      iframe.style.width = "1px";
      iframe.style.minWidth = "100%";
      iframe.style.display = "block";
      div.appendChild(iframe);
      if (options.target === null) {
        scripts.parentNode.insertBefore(div, scripts);
      } else {
        var target = document.getElementById(options.target);
        if (target === null) {
          alert(
            "Target not found, have you put the div#target after the script?",
          );
          return;
        }
        target.appendChild(div);
      }

      if (options.ga) {
        setTimeout(function () {
          google_track();
        }, 3000);
      }
    },
    done = function (event) {
      if (event.data.iframe) {
        var iframe = document.getElementsByName(event.data.iframe)[0],
          div = iframe.parentElement,
          intRegex = /^\d+$/;
        if (intRegex.test(event.data.height)) {
          log("Height received: " + event.data.height);
          // remove scrolling as we know we can get height from embed
          iframe.scrolling = "no";
          // datepickers and popovers can't overflow iFrame,
          // BUT can overflow wrapping div
          // so we make the iframe at 500px
          // and set the height of wrapping div to that of the content
          var new_height = Math.round(event.data.height);
          div.style.height = new_height + "px";
          iframe.height = new_height;

          log("Height changed to: " + new_height);

          // Force repaint
          // (Chrome can sometimes block overflow content being clicked)
          // https://stackoverflow.com/a/3485654
          if (!repainted) {
            div.style.display = "none";
            div.offsetHeight; // no need to store this anywhere, the reference is enough
            div.style.display = "";
            repainted = true;
            log("Forced repaint");
          }
        }

        if (event.data.clicked_date || event.data.scrollIntoView) {
          div.scrollIntoView({ behavior: "smooth" });
        }

        // Dynamically add and remove iframe buffer to handle overflowing content
        if (event.data.overflowIframe) {
          log(
            "overflowIframe: Setting iframe to a little taller than its containing div",
          );
          iframe.height = div.clientHeight + options.overflow;
        }
        if (event.data.containIframe) {
          log("containIframe: Setting iframe to exact containing div height");
          iframe.height = div.clientHeight;
        }
      }
    },
    checkSubDomain = function (str, theoptions) {
      if (theoptions && theoptions.host) {
        return true;
      } else {
        var pattern = new RegExp(
          /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi,
        );
        if (!pattern.test(str)) {
          if (str.match(/[^\-a-zA-Z0-9]/)) {
            alert(
              "Looks like you have invalid characters in your Inn Style subdomain.",
            );
            return false;
          }
          return true;
        } else {
          alert(
            "Looks like you entered a URL. Please try just your Inn Style subdomain.",
          );
          return false;
        }
      }
    },
    init = function (theoptions) {
      checkSubDomain(domain, theoptions);
      if (window.addEventListener) {
        addEventListener("message", done, false);
      } else {
        attachEvent("onmessage", done);
      }
      if (theoptions && theoptions !== undefined) {
        if (theoptions.constructor == String) {
          var a = theoptions.split("/"),
            b = {};
          ext(a, b);
        } else if (theoptions.constructor == Object) {
          ext(options, theoptions);
        }
      }
      window.innstyle_console_debug = options.console_debug;
      build();
    };
  this.create = function () {
    init(opts);
  };
  if (this.constructor != InnStyle) {
    new InnStyle(domain, opts).create();
  }
}).call();

Staylists = function (domain, opts) {
  if (typeof domain === "object") {
    // no domain provided, domain var is actually options
    InnStyle(null, domain);
  } else {
    InnStyle(domain, opts);
  }
};

Bliss = function (domain, opts) {
  Staylists(domain, opts);
};
